import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

type Props = SvgProps & {
  size?: number;
};

/**
 * Filled help/question icon used on the "Learn more why your interest rates
 * change" card. The icon is self-contained — it renders its own tinted circular
 * background (the `color` at 20% opacity) plus the question glyph, so it doesn't
 * need an extra wrapper circle.
 */
const CircleQuestionFilled = ({
  size = 24,
  color = '#00813B',
  ...props
}: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="24 466 24 24"
    fill="none"
    {...props}
  >
    <Path
      opacity={0.2}
      d="M36 487C40.9706 487 45 482.971 45 478C45 473.029 40.9706 469 36 469C31.0294 469 27 473.029 27 478C27 482.971 31.0294 487 36 487Z"
      fill={color}
    />
    <Path
      d="M35.75 483.5C36.1642 483.5 36.5 483.164 36.5 482.75C36.5 482.336 36.1642 482 35.75 482C35.3358 482 35 482.336 35 482.75C35 483.164 35.3358 483.5 35.75 483.5Z"
      fill={color}
    />
    <Path
      d="M36 479.5V478.75C37.6566 478.75 39 477.574 39 476.125C39 474.676 37.6566 473.5 36 473.5C34.3434 473.5 33 474.676 33 476.125V476.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M36 487C40.9706 487 45 482.971 45 478C45 473.029 40.9706 469 36 469C31.0294 469 27 473.029 27 478C27 482.971 31.0294 487 36 487Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default CircleQuestionFilled;
